<template>
    <Breadcrumbs
        main="Liste des types d'événement"
        mains="Liste des types d'événement"
        title="Paramètres"
    />
    <div class="container-fluid">
        <div class="row">
            <EventTypeList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const EventTypeList = defineAsyncComponent(
    () => import('@/components/theme/event/EventTypeList.vue'),
);
</script>